import { Box, Input, Text } from '@chakra-ui/react';
import { BaseFilterProps } from './types/types';
import { FilterContainerElement } from './FilterContainer';
import { toDateInputValue, toISOString } from '../../utils/helpers/dateHelper';
import { useTranslation } from 'react-i18next';

interface DatePickerFilterProps extends BaseFilterProps {
  value: string | null;
  onChange: (value: string | null) => void;
}

export function DatePickerFilterElement({
  name,
  value,
  onChange,
  onRemove,
  static: isStatic,
}: DatePickerFilterProps) {
  const { t } = useTranslation();

  return (
    <FilterContainerElement
      gridColumn="span 2"
      onRemove={onRemove}
      static={isStatic}
    >
      <Box p={2}>
        <Text
          fontSize="xs"
          color="gray.500"
          _dark={{ color: 'gray.400' }}
          mb={1}
        >
          {name}
        </Text>
        <Input
          type="date"
          size="sm"
          value={toDateInputValue(value)}
          onChange={(e) => onChange(toISOString(e.target.value))}
          placeholder={t('filter.selectDate')}
        />
      </Box>
    </FilterContainerElement>
  );
}
